<div class="board" aria-hidden="true">

  <div class="board__head">
    <span class="board__title">Precios de tu zona</span>
  </div>

  <!-- Los tres productos del portal. La pestaña activa rota sola: el mismo dato
       visto en otro combustible, y el tablero se reordena con él. -->
  <div class="board__products">
    <span
      class="board__pill"
      *ngFor="let item of products; trackBy: trackByProduct"
      [class.is-on]="item.key === active"
      [style.color]="item.key === active ? item.color : null"
    >{{ item.label }}</span>
  </div>

  <!-- Panel de gráfica con el tratamiento de Evolución: leyenda con la cifra de
       cada serie en la cabecera HTML, y el trazo debajo. -->
  <div class="chart-panel">
    <div class="chart-panel__head">
      <span class="chart-panel__legend">
        <span class="chart-panel__legend-item">
          <i class="chart-panel__mark" [style.background-color]="product.color"></i>
          <span class="chart-panel__legend-name">Tu estación</span>
          <strong class="chart-panel__legend-value">{{ ownValue }}</strong>
        </span>
        <span class="chart-panel__legend-item">
          <i class="chart-panel__mark chart-panel__mark--reference"></i>
          <span class="chart-panel__legend-name">Zona</span>
          <strong class="chart-panel__legend-value">{{ zoneValue }}</strong>
        </span>
      </span>

      <span class="chart-panel__delta" [class.is-down]="delta < 0">
        <i
          class="fa"
          [ngClass]="delta < 0 ? 'fa-arrow-down' : 'fa-arrow-up'"
          aria-hidden="true"
          *ngIf="delta !== 0"
        ></i>
        {{ deltaLabel }}
      </span>
    </div>

    <highcharts-chart
      class="chart-panel__plot"
      [Highcharts]="Highcharts"
      [options]="chartOptions"
      (chartInstance)="onChartInstance($event)"
    ></highcharts-chart>
  </div>

  <div class="board__columns">
    <span>Estación</span>
    <span class="board__col-price">{{ product.label }}</span>
    <span class="board__col-gap">Desvío vs. zona</span>
  </div>

  <!-- Las filas se posicionan por transform según su lugar en el orden de precio:
       cuando un competidor cambia, el tablero se reacomoda a la vista. -->
  <div class="board__rows" [style.height.px]="boardHeight">
    <div
      class="board__row"
      *ngFor="let row of rows; trackBy: trackByRow"
      [class.is-own]="row.own"
      [class.is-fresh]="row.fresh"
      [style.transform]="'translateY(' + rank(row) * rowHeight + 'px)'"
    >
      <span class="board__name">{{ row.name }}</span>

      <span class="board__price">{{ price(row) }}</span>

      <span class="board__gap">
        <span class="board__track">
          <i
            class="board__fill board__fill--under"
            [style.width.%]="gap(row) < 0 ? gapWidth(row) : 0"
          ></i>
          <i
            class="board__fill board__fill--over"
            [style.width.%]="gap(row) > 0 ? gapWidth(row) : 0"
          ></i>
        </span>
        <span class="board__cents" [class.is-over]="gap(row) > 0">{{ gapLabel(row) }}</span>
      </span>
    </div>
  </div>

  <div class="board__foot">
    <span class="board__foot-item">
      <span class="board__foot-label">Tu posición</span>
      <span class="board__foot-value">{{ ownRankLabel() }}</span>
    </span>
    <span class="board__foot-item">
      <span class="board__foot-label">Promedio de zona</span>
      <span class="board__foot-value">{{ averageLabel() }}</span>
    </span>
  </div>
</div>
